import { InputLabel } from '../../../common/components/form/fields';
import { FORM_RULES } from "../../../helpers/validations";

const inputStyle = { fontSize: "1.6rem", padding: 20, borderRadius: ".5rem" };
const style = {textAlign: 'left', fontSize: '1.6rem', fontWeight: 'bold'};

export default () => [
	{
		component: InputLabel,
		inputClass: "input--default",
		type: "text",
		name: "name",
        placeholder:"Nome",
		cols: "12 12 12 12",
		validate: [FORM_RULES.required],
		style,
		inputStyle
	},
	{
		component: InputLabel,
		inputClass: "input--default",
		type: "text",
		name: "email",
        placeholder:"Email",
		cols: "12 12 12 12",
		validate: [FORM_RULES.required, FORM_RULES.email],
		style,
        inputStyle
    },
	{
		component: InputLabel,
		inputClass: "input--default",
		type: "password",
		name: "password",
        placeholder:"Senha",
		cols: "12 12 12 12",
		validate: [FORM_RULES.required],
		style,
        inputStyle
    },
	{
		component: InputLabel,
		inputClass: "input--default",
		type: "password",
		name: "confirm_password",
        placeholder:"Confirmação da senha",
		cols: "12 12 12 12",
		validate: [FORM_RULES.required],
		style,
        inputStyle
    }
];
